import { startBishun } from "./bishun.js";
import { startXiezi } from "./xiezi-start.js";

/**
 * The script a 词典 entry for one 汉字 loads.
 *
 * A bundle of its own rather than bytes added to `site`, on the argument
 * `script-bundles.ts` makes about the search box. The figure is drawn on 9,276
 * of the section's 22,284 entries and on no other page of the site, and the
 * strokes it draws are a good deal more than the copy buttons are.
 *
 * `partials/cidian-bishun.html` is what loads it, so a page drawing the
 * figure gets the script and a page without one never asks for it. The tag is
 * `type="module"`, which defers, so the figure has been parsed by the time this
 * runs.
 *
 * The writing drill under the figure rides in the same bundle, since it is
 * drawn on the same pages and nowhere else, and it fetches nothing until the
 * reader opens it. See `xiezi-drill.ts`.
 */
startBishun(document);
startXiezi(document);
